
<template>
    <v-container fluid justify="center" 
      style="max-width: 616px; 
            background: white
            padding-left: 16px; 
            padding-right: 16px">

      <v-row>
        <v-col 
            cols="12"
            md="8"
            offset-md="2">

            <a @click="goBack">
                &#60; Indietro
            </a>

        </v-col>
      </v-row>

      <v-row id="main-content">
        <v-col 
            cols="12"
            md="8"
            offset-md="2">

            <h4 style="font-weight: normal">
                ({{fires.length}}) Segnalazioni precedenti
            </h4>

        </v-col>
      </v-row>

     <v-row>
        <v-col 
            cols="12"
            md="8"
            offset-md="2">

          <v-divider></v-divider>

          <v-list two-line>
            <template v-for="(fire, index) in fires">

              <v-list-item
                  :key="fire.guid" @click="onSelect(fire)"
                >

                <v-list-item-content>

                  <v-list-item-title class="primary--text"> {{fire.name}} {{fire.surname}} | +39 {{fire.phone}} </v-list-item-title>
                  <v-list-item-title class="primary--text"> {{fire.address}} {{fire.streetNumber}} {{fire.city}} {{fire.province}} </v-list-item-title>

                </v-list-item-content>

              </v-list-item>

              <v-divider
                v-if="index < fires.length"
                :key="index"
              ></v-divider>
            </template>
          </v-list>
        </v-col>
     </v-row>
    </v-container>
</template>

<script>
export default {
  name: "list-fires",
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$store.commit('setCurrentFire', null)
      this.$router.push({
        path:'/'
      })
    },
    onSelect(fire) {
      this.$store.commit('setCurrentFire', fire)
      this.$router.push({
        path:'/'
      })
    },
  },
  computed: {
    fires() {
      // console.log("this.$store.getters.fires: " + this.$store.getters.fires);
        return this.$store.getters.fires;
    }
  },
  mounted() {
    console.log("this.$store.getters.fires fireslist: ", this.$store.getters.fires);
  },
  created() {
  }
};
</script>

<style scoped lang="scss">
</style>